import { useState } from "react";
import { feed, feedStatusMap, type FeedItem } from "../../../mocks/homeData";
import SectionHeading from "./SectionHeading";

const statusFilters = [
  { key: "all", label: "全部动态", icon: "ri-stack-line" },
  { key: "heating", label: "发酵中", icon: "ri-fire-line" },
  { key: "watching", label: "持续关注", icon: "ri-eye-line" },
  { key: "recap", label: "事件复盘", icon: "ri-focus-3-line" },
  { key: "cleared", label: "已澄清", icon: "ri-verified-badge-fill" },
];

export default function TrackingFeed() {
  const [filter, setFilter] = useState("all");
  const list = feed.filter((f) => filter === "all" || f.status === filter);

  return (
    <section id="tracking" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="爆点追踪"
          title="热门话题发酵脉络"
          highlight="一路跟到底"
          desc="每一条进入追踪的大瓜，都会按发酵节点持续更新并标注状态，从“刚开始有动静”一直跟到尘埃落定。"
        />

        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {statusFilters.map((s) => (
            <button
              key={s.key}
              onClick={() => setFilter(s.key)}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-xs font-medium transition-colors cursor-pointer ${
                filter === s.key ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              <i className={`${s.icon} w-3.5 h-3.5 flex items-center justify-center`}></i>
              {s.label}
            </button>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-0">
          {list.length === 0 && (
            <div className="rounded-2xl border border-dashed border-background-300 px-6 py-12 text-center text-sm text-foreground-600">
              当前状态下暂无追踪条目。
            </div>
          )}
          {list.map((item, idx) => {
            const st = feedStatusMap[item.status];
            return (
              <div key={item.id} className="relative flex gap-4 md:gap-6">
                {/* timeline rail */}
                <div className="flex flex-col items-center">
                  <span className={`z-10 flex h-6 w-6 items-center justify-center rounded-full ring-4 ring-background-50 ${st.color}`}>
                    <span className="h-2 w-2 rounded-full bg-white"></span>
                  </span>
                  {idx < list.length - 1 && <span className="w-px flex-1 bg-background-200"></span>}
                </div>

                <article className="mb-6 flex-1 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 md:mb-8 md:p-6">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold text-white ${st.color}`}>
                      <i className="ri-record-circle-fill w-3 h-3 flex items-center justify-center"></i>
                      {st.label}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    <span className="text-xs text-foreground-400">·</span>
                    <span className="text-xs text-foreground-500">{item.stage}</span>
                  </div>
                  <h3 className="mt-3 font-serif text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">{item.brief}</p>
                  <div className="mt-4 flex items-center gap-1.5">
                    <span className="mr-1 text-[11px] text-foreground-500">发酵节点</span>
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span
                        key={i}
                        className={`h-1.5 rounded-full ${i < item.nodes ? "bg-primary-500" : "bg-background-200"}`}
                        style={{ width: i === 4 ? 40 : 16 }}
                      ></span>
                    ))}
                    <span className="ml-2 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                      查看脉络 <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    </span>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}